import React from "react";

import { LineInput } from "components/Inputs/LineInput";

import Waterfall from "components/Waterfall/Waterfall";

import styles from "./style.module.css";

export default class CostsWaterfall extends React.PureComponent {
  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  renderRow(label, count, impact) {
    const { hideCosts, isHeader, isBlueprint } = this.props;

    return (
      <div className={styles.costRow} style={hideCosts ? { height: "25%" } : {}}>
        <div className={styles.rowLabel}>
          <div className={styles.topLabel}>
            {isBlueprint ? (
              <div className={styles.blueLabel}>{label.label}</div>
            ) : (
              <LineInput
                defaultValue={label.label}
                onChange={(val) => label.update(val)}
                isBox
                isEditable
                isHeader={isHeader}
              />
            )}
          </div>
        </div>
        <div className={styles.countInput}>
          {isBlueprint ? (
            <div className={styles.blueLabel}>{count.label}</div>
          ) : (
            <LineInput
              inputType="int"
              defaultValue={count.label}
              onChange={(val) => count.update(val)}
              isBox
              isEditable
              isHeader={isHeader}
            />
          )}
        </div>
        {"X"}
        <div className={styles.costInputN}>
          <div className={styles.impactHolder}>
            {isBlueprint ? (
              <div className={styles.blueLabel}>{impact.label}</div>
            ) : (
              <LineInput
                inputType="int"
                defaultValue={impact.label}
                onChange={(val) => impact.update(val)}
                isBox
                isEditable
                isHeader={isHeader}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      currentROI,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      defaultTruePositive,
      defaultFalsePositive,
      netImpactLabel,
      blueprint,
      isShow,
      isHeader,
      isBlueprint,
      hideCosts,
      outcome,
      success,
      timePeriod,
      showTotal,
      showAbsTotal,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateNetImpactLabel
    } = this.props;

    const labelStyle = { width: "200px" };

    const waterfallBars = hideCosts
      ? [
          {
            label: truePositiveLabel,
            value: conversionGain * truePositive
          },
          {
            label: falsePositiveLabel,
            value: conversionCost * falsePositive
          }
        ]
      : [
          {
            label: truePositiveLabel,
            value: conversionGain * truePositive
          },
          {
            label: falsePositiveLabel,
            value: conversionCost * falsePositive
          },
          {
            label: trueNegativeLabel,
            value: conversionSaved * trueNegative
          },
          {
            label: falseNegativeLabel,
            value: conversionMissed * falseNegative
          }
        ];

    return (
      <div className={styles.body}>
        <div className={styles.outerHolder} style={isHeader ? { fontSize: "12px" } : {}}>
          <div className={styles.holder}>
            <div className={styles.leftCosts} style={isHeader ? { pointerEvents: "none" } : {}}>
              <div className={styles.costRow} style={{ height: "20px" }}>
                <div className={styles.rowLabel} />
                <div className={styles.countInputN}>{"Count"}</div>
                <div className={styles.costInputLabel}>{"Impact Per Prediction"}</div>
              </div>
              {this.renderRow(
                {
                  label: truePositiveLabel,
                  update: (val) => updateTruePositiveLabel(val)
                },
                {
                  label: truePositive,
                  update: (val) => updateTruePositive(val)
                },
                {
                  label: conversionGain,
                  update: (val) => updateConversionGain(val)
                }
              )}
              {this.renderRow(
                {
                  label: falsePositiveLabel,
                  update: (val) => updateFalsePositiveLabel(val)
                },
                {
                  label: falsePositive,
                  update: (val) => updateFalsePositive(val)
                },
                {
                  label: conversionCost,
                  update: (val) => updateConversionCost(val)
                }
              )}
              {this.renderRow(
                {
                  label: trueNegativeLabel,
                  update: (val) => updateTrueNegativeLabel(val)
                },
                {
                  label: trueNegative,
                  update: (val) => updateTrueNegative(val)
                },
                {
                  label: conversionSaved,
                  update: (val) => updateConversionSaved(val)
                }
              )}
              {this.renderRow(
                {
                  label: falseNegativeLabel,
                  update: (val) => updateFalseNegativeLabel(val)
                },
                {
                  label: falseNegative,
                  update: (val) => updateFalseNegative(val)
                },
                {
                  label: conversionMissed,
                  update: (val) => updateConversionMissed(val)
                }
              )}
              <div className={styles.costRow} style={hideCosts ? { height: "25%" } : {}}>
                <div className={styles.rowLabel}>
                  <div className={styles.topLabel}>
                    {isBlueprint ? (
                      <div className={styles.blueLabel}>{netImpactLabel}</div>
                    ) : (
                      <LineInput
                        defaultValue={netImpactLabel}
                        onChange={(val) => updateNetImpactLabel(val)}
                        isBox
                        isEditable
                        isHeader={isHeader}
                      />
                    )}
                  </div>
                  <div className={styles.botLabel}>{"Expected outcome of your current process per " + timePeriod}</div>
                </div>
              </div>
            </div>
            <div className={styles.costsWaterfall}>
              <div style={{ height: "20px" }} />
              {truePositive + falsePositive + trueNegative + falseNegative !== 0 && (
                <Waterfall bars={waterfallBars} totalLabel={netImpactLabel} roundTotal showAbsTotal={showAbsTotal} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
